import { createReducer } from '@reduxjs/toolkit'
import { set_brands } from "../confg";

const brands = createReducer([], {
    [set_brands]: (state, action) => {
        return action.payload
    },
});

export default brands;